export const environment = {
  production: true,
    urlPdv: 'https://pdv.toqweb.com.br/login/',
    urlToqWeb: 'https://app.toqweb.com.br/#/carregar-dados/',
};
